import {ref} from "vue";

export const  declineDays =(count) => {
  let number = typeof count === 'string' ? parseFloat(count) : count;

  const titles = ['день', 'дня', 'дней'];
  const cases = [2, 0, 1, 1, 1, 2];

  // Если не целое число — использовать "дней"
  if (!Number.isInteger(number)) {
    return titles[2]; // "дней"
  }

  const index =
    (number % 100 > 4 && number % 100 < 20)
      ? 2
      : cases[(number % 10 < 5) ? number % 10 : 5];

  return titles[index];
}

export const  declineManager =(count) => {
  let number = typeof count === 'string' ? parseFloat(count) : count;

  const titles = ['менежер', 'менеджера', 'менеджеров'];
  const cases = [2, 0, 1, 1, 1, 2];

  // Если не целое число — использовать "дней"
  if (!Number.isInteger(number)) {
    return titles[2]; // "дней"
  }

  const index =
    (number % 100 > 4 && number % 100 < 20)
      ? 2
      : cases[(number % 10 < 5) ? number % 10 : 5];

  return titles[index];
}

export const getColor = (item, index, invert) => {
  let num = item
  if(typeof num === 'number') {
    num = num.toString()
  }
  if(typeof num === 'string') {
    if(invert) return num < -1 ? 'color:#26A659!important;' : 'color:#DD4646!important;'
    return num > -1 ? 'color:#26A659!important;' : 'color:#DD4646!important;'
  }
}

export const progressStyle = (colorType, percent) => {
  const color = colorType > -1 ? "rgba(38, 166, 89, 0.1)" : "rgba(221, 70, 70, 0.1)";
  return {
    width: `${percent}%`,
    background: color,
    height: `100%`,
  }
}

export const getFormatCount = (count, withoutInterest) => {
  if(withoutInterest) return count < 1 ? `${count}` : `+${count}`;
  return count < 1 ? `${count}%` : `+${count}%`;
}

export const getFormatCountWithoutPlus = (count, withoutInterest) => {
  if(withoutInterest) return count < 1 ? `${count}` : `${count}`;
  return count < 1 ? `${count}%` : `${count}%`;
}

export const formatNum = (num, decimalPlaces = undefined) => {
  if (num === undefined || num === null) return '';

  let processedNum = num;

  // Округляем до нужного количества знаков, если указан decimalPlaces
  if (decimalPlaces !== undefined) {
    const multiplier = Math.pow(10, decimalPlaces);
    processedNum = Math.round(num * multiplier) / multiplier;
  }

  const str = processedNum.toString();
  return str.includes('.') ? str.replace('.', ',') : str;
};